import React from "react";
import {Route} from "react-router-dom";


const module = (shopApp) => {
	const FrequentlyAskedQuestions = shopApp.dynamic(() => import("./FrequentlyAskedQuestions"));

	const url = "/faq";

	let config = {
		name: "FrequentlyAskedQuestions",
		routes: [
			<Route key={url} exact path={url} component={FrequentlyAskedQuestions}/>
		]
	};

	shopApp.registerPage(config);

};

export default module;
